"use strict";
import { makeStyles } from "@mui/styles";
export default makeStyles(() => ({
  root: {
    display: "flex",
    backgroundColor: "white",
    flexDirection: "column",
    width: "100%",
    padding: "50px 60px 20px 60px",
    minHeight: 630,
    maxHeight: 630,
    height: 630,
    "& h4": {
      marginTop: 0,
      color: "#004E70",
      fontSize: 26,
      fontWeight: 700,
      marginBottom: 30
    }
  },
  buttonContainer: {
    marginTop: "auto",
    paddingTop: 30,
    display: "flex",
    justifyContent: "flex-end",
    "& button": {
      padding: "12px 26px",
      color: "#FFF",
      minHeight: 50,
      "&:last-child": {
        marginLeft: 12
      }
    },
    "&.move-z": {
      marginBottom: -20,
      paddingBottom: 20,
      zIndex: 2,
      background: "linear-gradient(rgba(255,255,255,0), rgba(255,255,255,0.5), rgba(255,255,255,1), rgba(255,255,255,1))"
    }
  },
  buttonIcon: {
    fontSize: "1.7rem",
    width: "0.8rem"
  },
  name: {
    fontSize: 21,
    color: "#000",
    userSelect: "none"
  },
  details: {
    color: "#939393",
    fontSize: 16,
    marginBottom: 8,
    userSelect: "none"
  },
  footer: {
    borderTop: "1px solid #DDDDDD",
    padding: "10px 26px",
    display: "flex",
    justifyContent: "space-between"
  },
  copyButton: {
    fontWeight: 400,
    fontSize: 10,
    padding: "4px 10px !important"
  },
  shadow: {
    boxShadow: "rgb(0 0 0 / 55%) -4px -33px 15px -45px inset"
  },
  loading: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%"
  },
  noEvents: {
    color: "#999",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flex: 1
  }
}));
